export default __webpack_public_path__ + "static/media/Bracers of the Unholy Communion.c1837f28.jpg";